module.exports = __webpack_public_path__ + "img/stock6.ab9ca5bc.png";